'use client'

import { motion } from "framer-motion"
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { Minus, Plus } from 'lucide-react'

interface Detail {
  name: string
  desc: any
}

export default function ProductDropdown({ details = [] }: { details: Detail[] }) {
  return (
    <motion.dl className="space-y-4 max-w-2xl mx-auto" initial={{ opacity: 0, y: -10 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0, duration: 0.5, ease: "easeIn" }} viewport={{ once: true }}>
      {details.map((detail) => (
        <Disclosure as="div" key={detail.name} className="py-3 divive-y divide-muted-foreground/10 border-t">
          {({ open }) => (
            <>
              <dt>
                <DisclosureButton className="flex w-full items-center justify-between text-left text-foreground">
                  <span className="text-sm font-semibold leading-[26px] text-foreground">{detail.name}</span>
                  <span className="ml-6 flex h-7 items-center">
                    {open ? (
                      <Minus className="h-4 w-4 text-foreground" aria-hidden="true" />
                    ) : (
                      <Plus className="h-4 w-4 text-foreground" aria-hidden="true" />
                    )}
                  </span>
                </DisclosureButton>
              </dt>
              <DisclosurePanel as="dd" className="mt-4 pr-2">
                <div className="text-sm leading-6 text-muted-foreground">{detail.desc}</div>
              </DisclosurePanel>
            </>
          )}
        </Disclosure>
      ))}
    </motion.dl>
  )
}